<template>
  <div class="p-4 space-y-2">
    <div class="flex items-center justify-between mb-2">
      <h3 class="text-xs font-semibold text-gray-800">Tasks</h3>
      <button class="text-xs px-3 py-1.5 rounded bg-gray-900 text-white hover:bg-gray-800" @click="openNew">+ New</button>
    </div>

    <LoadingIndicator v-if="loading" message="Loading…" />
    <div v-else-if="!grouped.length" class="text-xs text-gray-400 text-center py-6">No tasks yet</div>

    <div v-else class="space-y-2">
      <div v-for="group in grouped" :key="group.name" class="border border-gray-200 rounded">
        <div class="px-3 py-2 bg-gray-50 flex items-center justify-between border-b border-gray-200">
          <div class="text-xs font-medium text-gray-800">
            {{ group.name }}
            <span class="text-[10px] px-1 py-0.5 rounded bg-purple-50 text-purple-700 font-mono ml-1">latest v{{ group.versions[0].version }}</span>
            <span class="text-[10px] text-gray-400 ml-1">{{ group.versions.length }} version{{ group.versions.length === 1 ? '' : 's' }}</span>
          </div>
          <button class="text-[11px] text-gray-700 hover:text-gray-900" @click="openEdit(group.versions[0])">+ New version</button>
        </div>
        <div class="divide-y divide-gray-100">
          <div
            v-for="v in group.versions"
            :key="v.id"
            @click="openEdit(v)"
            class="px-3 py-1.5 text-[11px] text-gray-700 flex items-center gap-2 hover:bg-gray-50 cursor-pointer"
          >
            <span class="font-mono text-gray-400 w-10">v{{ v.version }}</span>
            <span
              class="text-[10px] px-1 py-0.5 rounded"
              :class="v.active ? 'text-green-700 bg-green-50' : 'text-gray-400 bg-gray-100'"
            >{{ v.active ? 'active' : 'off' }}</span>
            <span class="text-gray-500 truncate flex-1">{{ v.description || '—' }}</span>
            <span class="text-[10px] text-gray-400">{{ formatDate(v.created_at) }}</span>
          </div>
        </div>
      </div>
    </div>

    <TaskModal
      v-if="showModal"
      :initial="editing"
      @close="showModal = false"
      @saved="onSaved"
    />
  </div>
</template>

<script>
import axios from 'axios'
import LoadingIndicator from '@/components/widgetcomponents/library/LoadingIndicator.vue'
import TaskModal from './TaskModal.vue'

const API_BASE = 'api/intelligence/'

export default {
  name: 'TasksView',
  components: { LoadingIndicator, TaskModal },

  data() {
    return {
      tasks: [],
      loading: true,
      showModal: false,
      editing: {},
    }
  },

  computed: {
    grouped() {
      const groups = {}
      for (const t of this.tasks) {
        if (!groups[t.name]) groups[t.name] = []
        groups[t.name].push(t)
      }
      return Object.entries(groups)
        .map(([name, versions]) => ({
          name,
          versions: versions.slice().sort((a, b) => b.version - a.version),
        }))
        .sort((a, b) => a.name.localeCompare(b.name))
    },
  },

  methods: {
    async fetchAll() {
      this.loading = true
      try {
        const { data } = await axios.get(`${API_BASE}tasks/`)
        this.tasks = data.results || data
      } catch (e) {
        console.error('TasksView load failed:', e)
      } finally {
        this.loading = false
      }
    },
    openNew() { this.editing = {}; this.showModal = true },
    openEdit(t) { this.editing = t; this.showModal = true },
    onSaved() { this.showModal = false; this.fetchAll() },
    formatDate(iso) {
      if (!iso) return ''
      return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
    },
  },

  mounted() { this.fetchAll() },
}
</script>
